module.exports = __webpack_public_path__ + "img/project-24.3dd73b45.png";